import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import './CallToActions.scss';

export default class CallToActions extends PureComponent {
  static defaultProps = {
    className: '',
  };

  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    if (this.props.children) {
      return <div className={`ctas d-flex flex-wrap justify-content-center ${this.props.className}`}>
        {this.props.children}
      </div>
    }

    return null;
  }
}
